export default "__VITE_ASSET__f6055ffa__"